import React, { useState } from 'react';
import axios from 'axios';

// API Base URL - Use environment variable with fallback
import { API_BASE_URL } from "../../apiConfig";

const LocationEditModal = ({ isOpen, onClose, currentLocation, onSave }) => {
  const [location, setLocation] = useState(currentLocation || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!location.trim()) {
      setError('Location is required');
      return;
    }

    try {
      setSaving(true);
      setError('');
      
      const token = localStorage.getItem('token');
      const cleanToken = token.replace(/^"(.*)"$/, '$1');

      const response = await axios.put(
        `${API_BASE_URL}/api/seller/profile/location`,
        { location: location.trim() },
        {
          headers: {
            Authorization: `Bearer ${cleanToken}`,
            'Content-Type': 'application/json'
          },
          timeout: 30000,
        }
      );

      onSave(response.data.location);
      onClose();
    } catch (error) {
      console.error('Error updating location:', error);
      setError(error.response?.data?.message || 'Failed to update location. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-gray-800">Edit Location</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl"
              disabled={saving}
            >
              &times;
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Your Location
              </label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#708238] focus:border-[#708238] outline-none"
                placeholder="e.g., Karachi, Pakistan"
                disabled={saving}
              />
              <p className="text-gray-500 text-xs mt-1">
                Enter your city and country
              </p>
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium rounded-lg border border-gray-300 hover:border-gray-400 transition-colors"
                disabled={saving}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-[#708238] text-white font-medium rounded-lg hover:bg-[#5a6a2d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                disabled={saving}
              >
                {saving ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Saving...
                  </>
                ) : (
                  'Save Location'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LocationEditModal;
